import { useState } from 'react';
import { toast } from 'sonner';
import { FormModal } from '@/components/shared/form-modal';
import { Field } from '@/components/shared/field';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { errorMessage } from '@/lib/api';
import { useOpenRegister } from '../api';
import { MoneyInput } from '../money-input';

export function OpenRegisterModal({ open, onOpenChange, branchId, branchName }: { open: boolean; onOpenChange: (v: boolean) => void; branchId: string; branchName?: string }) {
  const [amount, setAmount] = useState(0);
  const [notes, setNotes] = useState('');
  const mut = useOpenRegister();

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    try {
      await mut.mutateAsync({ branchId, openingAmountCents: amount, notes: notes.trim() || undefined });
      toast.success('Caixa aberto.');
      setAmount(0);
      setNotes('');
      onOpenChange(false);
    } catch (err) {
      toast.error(errorMessage(err));
    }
  }

  return (
    <FormModal
      open={open}
      onOpenChange={onOpenChange}
      size="sm"
      title="Abrir caixa"
      description={branchName ? `Unidade ${branchName}. Informe o dinheiro que está na gaveta agora.` : 'Informe o dinheiro que está na gaveta agora.'}
      footer={
        <>
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
            Voltar
          </Button>
          <Button type="submit" form="open-register-form" disabled={mut.isPending}>
            {mut.isPending ? 'Abrindo…' : 'Abrir caixa'}
          </Button>
        </>
      }
    >
      <form id="open-register-form" onSubmit={submit} className="grid gap-4">
        <Field id="open-amount" label="Valor inicial em dinheiro">
          <MoneyInput id="open-amount" value={amount} onChange={setAmount} />
        </Field>
        <Field id="open-notes" label="Observações (opcional)">
          <Textarea id="open-notes" value={notes} onChange={(e) => setNotes(e.target.value)} maxLength={300} rows={2} />
        </Field>
      </form>
    </FormModal>
  );
}
